import { useMemo } from 'react';

import { Student } from '@givebacks/api/student';
import { ClickableOptionsCard } from 'core/Components';
import { Avatar, Divider } from 'ui';

type StudentDisplayCardProps = {
  student: Student;
  onClick: () => void;
};

const StudentDisplayCard = ({ student, onClick }: StudentDisplayCardProps) => {
  const studentName = useMemo(
    () => `${student.first_name} ${student.last_name}`,
    [student.first_name, student.last_name]
  );
  return (
    <ClickableOptionsCard.Row
      leftSection={<Avatar name={studentName} color="cobalt.5" />}
      title={studentName}
      subtitle={`${student.cause.name} · Grade ${student.grade}`}
      onClick={onClick}
    >
      <Divider size="xs" color="cobalt.0" />
    </ClickableOptionsCard.Row>
  );
};

export { StudentDisplayCard };
